import { jsx as i } from "react/jsx-runtime";
import { chakra as l } from "@chakra-ui/system";
import { cx as m } from "@chakra-ui/utils";
import * as r from "react";
const p = ({
  customClassname: o,
  styleConfig: s,
  children: e,
  ...a
}) => {
  const t = r.isValidElement(e) ? r.cloneElement(e, {
    // @ts-ignore
    "aria-hidden": !0,
    focusable: !1,
    flexShrink: 0,
    w: "100%",
    h: "100%"
  }) : e;
  return /* @__PURE__ */ i(
    l.span,
    {
      display: "inherit",
      ...a,
      className: m(o, a.className),
      __css: s,
      children: t
    }
  );
};
export {
  p as UtilStyledIcon
};
